import React from "react";
import { useSearchParams } from "react-router-dom";
import { ButtonLink } from "../../../components/atoms/ButtonLink/ButtonLink";
import { MdGroups, MdLink } from "react-icons/md";
import { RegistrationForm } from "../../../components/organism/RegistrationForm/RegistrationForm";
import { GeneralLayout } from "../../../components/layout/GeneralLayout/GeneralLayout";

export const RegistrationPage: React.FC = () => {
  // Hook para leer los parámetros de la URL (ej: ?ref=123)
  const [searchParams] = useSearchParams();
  const referrerId = searchParams.get("ref") || undefined;

  return (
    <GeneralLayout>
      <RegistrationForm referrerId={referrerId} />
      <div className="flex md:gap-5 gap-5 md:flex-row flex-col w-full max-w-screen-lg mt-5 pl-5 pr-5 md:p-0">
        <ButtonLink path="/recoverlink">
          <MdLink className="inline mr-2" size={20} />
          Recuperar mi enlace
        </ButtonLink>
        <ButtonLink path="/searchmynetwork">
          <MdGroups className="inline mr-2" size={20} />
          Ver mi red
        </ButtonLink>
      </div>
    </GeneralLayout>
  );
};
